<template>
  <card class="card" title=""><br />
    <div class="row">
      <div class="col-md-4">
        <div class="input-group mb-3">
          <input type="text" class="form-control" placeholder="Buscar ..." v-model="word" />
          <div class="input-group-append">
            <button class="btn btn-info" type="info" @click="() => { page = 1; getUsers() }">
              <i class="material-icons white-text">search</i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-4"></div>
      <div class="col-md-4" :style="{ paddingRight: '33px' }" title="Agregar">
        <div class="d-flex justify-content-end">
          <button class="btn btn-success" type="info" @click="() => { this.$router.push('/crear-usuario') }">
            <i class="material-icons white-text">add</i>
          </button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <div class="col-md-12">
        <table class="table table-striped">
          <thead class="table-dark">
            <tr>
              <th v-for="col in headers" :key="col.label">{{ col.label }}</th>
            </tr>
          </thead>
          <tbody v-if="content.length > 0">
            <tr v-for="(us) in content" :key="us.id">
              <td>{{ us.username }}</td>
              <td>{{ us.firstName }}</td>
              <td>{{ us.email }}</td>
              <!-- <td>Deshabilitadas temporalmente</td> -->
              <td>
                <i class="material-icons white-text" :style="{ cursor: 'pointer', color: 'red' }"
                  @click="() => deleteItem(us.id, us.username)" title="Eliminar">
                  delete
                </i>
                <i class="material-icons white-text" :style="{ cursor: 'pointer', color: '#17a2b8' }"
                  @click="() => modifyItem(us.id)" title="Modificar">
                  edit
                </i>
              </td> 
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="4" style="background-color:#eee;">
              <center> Información no encontrada </center>
            </td>
            </tr>
          </tbody>

        </table>
        <div v-if="content.length > 0">
          <p class="text-right" :style="{ paddingRight: '11px' }" v-if="count > (page * 5)">
            {{ ((page - 1) * 5) + 1 }} - {{ page * 5 }} de {{ count }} registros
          </p>
          <p class="text-right" :style="{ paddingRight: '11px' }" v-else>
            {{ ((page - 1) * 5) + 1 }} - {{ count }} de {{ count }} registros
          </p><br />
        </div>
        <div v-else> </div>
      </div><br/>

      <div class="d-flex justify-content-center">
        <b-pagination v-model="page" :total-rows="count" prev-text="Anterior" next-text="Siguiente" :per-page="5"
          @change="handlePageChange" />
      </div>
    </div>
  </card>
</template>

<script>
import usersService from '../../services/usersService';
import state from "../../store/state";

export default {
  name: "users",
  data() {
    return {
      headers: [],
      content: [],
      currentUser: null,
      currentIndex: -1,
      word: "",

      page: 1,
      count: 0
    };
  },
  methods: {
    getRequestParams(page, word) {
      let params = {};

      if (page) {
        params["page"] = page - 1;
      }

      if (word) {
        params["word"] = word;
      }

      return params;
    },

    async getUsers() {
      const params = this.getRequestParams(
        this.page,
        this.word
      );
      const users = await usersService.getUsers(params.page, params.word);
      const { content } = await users.data.data;
      const { totalElements } = await users.data.data;
      this.count = totalElements;
      this.content = content;
    },

    handlePageChange(value) {
      this.page = value;
      this.getUsers();
    },

    refreshList() {
      this.getUsers();
      this.currentUser = null;
      this.currentIndex = -1;
    },

    setActiveUser(user, index) {
      this.currentUser = user;
      this.currentIndex = index;
    },

    deleteItem(id, us) {
      swal({
        title: '¡Aviso!',
        text: '¿Eliminar usuario ' + us + '?',
        icon: 'warning',
        buttons: true,
      }).then((result) => {
        if (result) {
          usersService.delete(id).then(response => {
            if (response.data.error === false) {
              swal({
                title: 'Exitoso',
                text: 'Se elimino al usuario correctamente',
                icon: 'success',
                timer: 3000,
                buttons: false
              })
              setTimeout(() => {
                window.location.reload()
              }, 3000)
            } else {
              swal({
                title: '¡Algo salio mal!',
                text: 'Consulte con el administrador',
                icon: 'warning',
                timer: 3000,
                buttons: false
              })
            }
          })
        }
      })
    },

    modifyItem(id) {
      this.$router.push("/editar-usuario/" + id);
    }

  },
  mounted() {
    this.getUsers();
    this.content = state.users.list;
    this.headers = state.users.headers;
  },
};
</script>

<style>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}
.material-icons {
  line-height: 0.6 !important;
}
</style>
